import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Icon} from '../../atoms/Icon/Icon';
import {IconName} from '../../atoms/Icon/IconName';
import {Text} from '../../atoms/Text/Text';

type BadgePart = {
  label: string;
  backgroundColor?: string;
  icon?: IconName;
};

interface SplitBadgeProps {
  start: BadgePart;
  end: BadgePart;
  className?: string;
  testId?: string;
  foregroundColor?: string;
  fontSize?: keyof typeof FONT_SIZES;
  weight?: keyof typeof FONT_WEIGHTS;
}

export const SplitBadge: FC<SplitBadgeProps> = ({
  start,
  end,

  foregroundColor,
  className,
  testId,
  fontSize = 'px10',
  weight = 'mediumHeavy',
}) => {
  return (
    <Wrapper className={className} data-testid={testId || 'split-badge'}>
      <StyledText
        size={fontSize}
        weight={weight}
        $foregroundColor={foregroundColor}
        $backgroundColor={start.backgroundColor}
        data-testid="start"
      >
        {start.icon && (
          <DisplayIcon asset={start.icon} size="S" fill={foregroundColor} />
        )}
        {start.label}
      </StyledText>
      <StyledText
        size={fontSize}
        weight={weight}
        $foregroundColor={foregroundColor}
        $backgroundColor={end.backgroundColor}
        data-testid="end"
      >
        {end.icon && (
          <DisplayIcon asset={end.icon} size="S" fill={foregroundColor} />
        )}
        {end.label}
      </StyledText>
    </Wrapper>
  );
};

const StyledText = styled(Text)<{
  $foregroundColor: SplitBadgeProps['foregroundColor'];
  $backgroundColor: BadgePart['backgroundColor'];
}>`
  background-color: ${props => props.$backgroundColor || ''};
  color: ${props => props.$foregroundColor || ''};
  display: flex;
  width: 100%;
  justify-content: center;
  line-height: 18px;
  overflow: hidden;
  flex-wrap: wrap;

  border-radius: 4px 0 0 4px;
  &:last-child {
    border-radius: 0 4px 4px 0;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  padding: 0 4px;
  height: 19px;
`;

const DisplayIcon = styled(Icon)`
  margin-top: -2.5px;
  margin-left: -6px;
  scale: 0.6;
`;
